(function () {
  // ---------- Announcement bar rotation ----------
  const track = document.querySelector('[data-fc-announce]');
  if (track) {
    let messages;
    try { messages = JSON.parse(track.dataset.messages || '[]'); } catch (e) { messages = []; }

    // Scale USD threshold amounts (e.g. "$100") to the active presentment
    // currency using the shared fluffcoMoney helper so every section formats
    // the same way (proper Intl symbol, locale-aware grouping).
    (function () {
      var fmt = window.fluffcoMoney;
      if (!fmt) return;
      messages = messages.map(function (m) {
        var h = m.highlight && m.highlight.match(/^\$(\d+)$/)
          ? fmt(parseInt(RegExp.$1, 10))
          : m.highlight;
        var t = m.text && m.text.match(/\$(\d+)/)
          ? m.text.replace(/\$(\d+)/, function (_, n) { return fmt(parseInt(n, 10)); })
          : m.text;
        return { text: t, highlight: h, suffix: m.suffix };
      });
    })();
    if (messages.length > 1) {
      let i = 0;
      const render = (m) => {
        const t = document.createTextNode(m.text || '');
        const h = document.createElement('span');
        h.className = 'fc-announce__highlight';
        h.textContent = m.highlight || '';
        const s = document.createTextNode(m.suffix || '');
        track.innerHTML = '';
        track.appendChild(t);
        track.appendChild(h);
        track.appendChild(s);
      };
      setInterval(() => {
        track.setAttribute('data-fading', 'true');
        setTimeout(() => {
          i = (i + 1) % messages.length;
          render(messages[i]);
          track.setAttribute('data-fading', 'false');
        }, 350);
      }, 3500);
    }
  }

  // ---------- FlashSaleBanner countdown ----------
  const flash = document.querySelector('[data-fc-flash]');
  if (flash) {
    const hrsEl = flash.querySelector('[data-fc-flash-hrs]');
    const minEl = flash.querySelector('[data-fc-flash-min]');
    const secEl = flash.querySelector('[data-fc-flash-sec]');
    const closeBtn = flash.querySelector('[data-fc-flash-close]');
    const pad = (n) => String(n).padStart(2, '0');

    const tick = () => {
      const now = new Date();
      const midnight = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0, 0);
      const diff = midnight.getTime() - now.getTime();
      if (diff <= 0) {
        flash.setAttribute('data-dismissed', 'true');
        syncHeaderBottom();
        return;
      }
      const totalSeconds = Math.floor(diff / 1000);
      const hrs = Math.floor(totalSeconds / 3600);
      const mins = Math.floor((totalSeconds % 3600) / 60);
      const secs = totalSeconds % 60;
      if (hrsEl) hrsEl.textContent = pad(hrs);
      if (minEl) minEl.textContent = pad(mins);
      if (secEl) secEl.textContent = pad(secs);
    };
    tick();
    setInterval(tick, 1000);

    if (closeBtn) {
      closeBtn.addEventListener('click', () => {
        flash.setAttribute('data-dismissed', 'true');
        syncHeaderBottom();
      });
    }
  }

  // ---------- Sync mobile drawer's top to header bottom ----------
  const header = document.querySelector('.fc-header');
  function syncHeaderBottom() {
    if (!header) return;
    const rect = header.getBoundingClientRect();
    document.documentElement.style.setProperty('--fc-header-bottom', rect.bottom + 'px');
  }
  syncHeaderBottom();
  window.addEventListener('resize', syncHeaderBottom);
  window.addEventListener('scroll', syncHeaderBottom, { passive: true });

  // ---------- Mega menu hover + click (desktop) ----------
  // A11y: when the menu opens via keyboard activation OR programmatic click,
  // move focus into the first link inside it. The CSS toggles the menu from
  // display:none → display:block with an 180ms fadeInDown animation, so we
  // attempt focus at multiple intervals to land *after* layout commits.
  // Diagnostics are intentionally left in so the audit can verify in console.

  // Global modality tracker — attach ONCE, not per-trigger.
  let lastInputWasKeyboard = false;
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' || e.key === ' ' || e.key === 'Tab') lastInputWasKeyboard = true;
  }, true);
  document.addEventListener('mousedown', () => { lastInputWasKeyboard = false; }, true);

  document.querySelectorAll('[data-fc-megatrigger]').forEach((trigger) => {
    const targetId = trigger.dataset.fcMegatrigger;
    const target = document.getElementById(targetId);
    if (!target) return;
    let timer;

    const findFirstLink = () => {
      // Audit diagnostic #4: verify the query returns a real focusable.
      const link = target.querySelector('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])');
      console.log('[FC megamenu] findFirstLink →', link, 'tagName:', link && link.tagName);
      return link;
    };

    const focusFirstInMenu = (attempt) => {
      const link = findFirstLink();
      if (!link) {
        console.warn('[FC megamenu] no focusable child found in', targetId);
        return false;
      }
      // Audit diagnostic: release the trigger's focus before grabbing it elsewhere.
      // Without this, a click event's default behavior re-focuses the trigger
      // *after* our handler runs.
      if (document.activeElement === trigger) trigger.blur();
      // Focus container first (always focusable via tabindex=-1). If the
      // first link is unfocusable due to in-flight animation/CSS, focus
      // still lands INSIDE the menu, satisfying the WCAG menu pattern.
      target.focus({ preventScroll: true });
      link.focus({ preventScroll: false });
      // Audit diagnostic #2: see what actually has focus.
      const landed = document.activeElement === link;
      console.log('[FC megamenu] focus attempt', attempt, '→ activeElement:', document.activeElement, 'landed?', landed);
      return landed;
    };

    // Wait for: (1) next paint frame so display:block commits, then (2) past
    // the 180 ms CSS fadeInDown animation. Retry at 50/150/300 ms in case
    // the first attempt is swallowed by the click event's default focus.
    const focusFirstSoon = () => {
      requestAnimationFrame(() => {
        if (focusFirstInMenu('rAF')) return;
        setTimeout(() => {
          if (focusFirstInMenu('50ms')) return;
          setTimeout(() => {
            if (focusFirstInMenu('150ms')) return;
            setTimeout(() => focusFirstInMenu('300ms'), 150);
          }, 100);
        }, 50);
      });
    };

    const open = () => {
      clearTimeout(timer);
      target.setAttribute('data-open', 'true');
      trigger.setAttribute('aria-expanded', 'true');
    };
    const close = () => {
      target.setAttribute('data-open', 'false');
      trigger.setAttribute('aria-expanded', 'false');
    };
    const closeSoon = () => { timer = setTimeout(close, 150); };

    trigger.addEventListener('mouseenter', open);
    trigger.addEventListener('mouseleave', closeSoon);
    target.addEventListener('mouseenter', open);
    target.addEventListener('mouseleave', closeSoon);

    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      // Audit diagnostic #1: confirm handler fires.
      console.log('[FC megamenu] trigger click; detail=', e.detail, 'lastInputWasKeyboard=', lastInputWasKeyboard);
      const isOpen = target.getAttribute('data-open') === 'true';
      if (isOpen) {
        close();
      } else {
        // Always shift focus on click — covers keyboard activation
        // (detail === 0), programmatic .click() in tests, AND real mouse
        // clicks (which is harmless; keyboard users get the benefit, mouse
        // users don't notice the focus shift since they're using a mouse).
        open();
        focusFirstSoon();
      }
    });

    // Escape closes the menu and returns focus to the trigger.
    target.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && target.getAttribute('data-open') === 'true') {
        e.preventDefault();
        close();
        trigger.focus();
      }
    });
  });

  // ---------- Mobile drawer toggle ----------
  const drawer = document.querySelector('[data-fc-drawer]');
  const openBtn = document.querySelector('[data-fc-drawer-open]');
  if (drawer && openBtn) {
    openBtn.addEventListener('click', () => {
      syncHeaderBottom();
      const isOpen = drawer.getAttribute('data-open') === 'true';
      drawer.setAttribute('data-open', isOpen ? 'false' : 'true');
      openBtn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      openBtn.setAttribute('aria-label', isOpen ? 'Menu' : 'Close menu');
      document.body.style.overflow = isOpen ? '' : 'hidden';
    });
  }

  // ---------- Mobile Shop accordion ----------
  const shopBtn = document.querySelector('[data-fc-mobile-shop]');
  const shopContent = document.querySelector('[data-fc-mobile-shop-content]');
  if (shopBtn && shopContent) {
    shopBtn.addEventListener('click', () => {
      const isOpen = shopBtn.getAttribute('aria-expanded') === 'true';
      shopBtn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      shopContent.setAttribute('data-open', isOpen ? 'false' : 'true');
    });
  }

  // ---------- Country/currency dropdown (desktop) ----------
  const countryToggle  = document.querySelector('[data-fc-country-toggle]');
  const countryDropdown = document.querySelector('[data-fc-country-dropdown]');
  if (countryToggle && countryDropdown) {
    countryToggle.addEventListener('click', (e) => {
      e.stopPropagation();
      const isOpen = countryToggle.getAttribute('aria-expanded') === 'true';
      countryToggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      countryDropdown.setAttribute('aria-hidden', isOpen ? 'true' : 'false');
    });
    document.addEventListener('click', (e) => {
      if (!countryToggle.contains(e.target) && !countryDropdown.contains(e.target)) {
        countryToggle.setAttribute('aria-expanded', 'false');
        countryDropdown.setAttribute('aria-hidden', 'true');
      }
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        countryToggle.setAttribute('aria-expanded', 'false');
        countryDropdown.setAttribute('aria-hidden', 'true');
      }
    });
  }

  // ---------- GeoIP auto-switch ----------
  // Uses Shopify's built-in browsing context endpoint — no external API needed.
  // Only fires once per session and only if the user hasn't already chosen manually.
  const GEO_PREF_KEY = 'fc_country_set';
  if (!sessionStorage.getItem(GEO_PREF_KEY) && localStorage.getItem(GEO_PREF_KEY) !== 'manual') {
    // Mark that we've run geo-detection this session so it doesn't re-fire
    sessionStorage.setItem(GEO_PREF_KEY, '1');
    fetch('/browsing_context_suggestions.json')
      .then((r) => r.json())
      .then((data) => {
        const detected = data && data.detected_values && data.detected_values.country
          ? data.detected_values.country.handle
          : null;
        if (!detected) return;
        // Current country is embedded by Liquid into a data attribute on the toggle
        const current = countryToggle ? countryToggle.getAttribute('data-current-country') : null;
        if (current && detected.toUpperCase() === current.toUpperCase()) return;
        // Find a localization form whose country_code matches the detected country
        const matchingForm = document.querySelector(
          `.fc-country-dropdown form input[value="${detected.toUpperCase()}"]`
        );
        if (matchingForm) {
          matchingForm.closest('form').submit();
        }
      })
      .catch(() => {}); // silently ignore — geo is best-effort
  }

  // Mark a manual selection so GeoIP doesn't override it next session
  if (countryDropdown) {
    countryDropdown.querySelectorAll('form').forEach((form) => {
      form.addEventListener('submit', () => {
        sessionStorage.setItem(GEO_PREF_KEY, 'manual');
        localStorage.setItem(GEO_PREF_KEY, 'manual');
      });
    });
  }

  // ---------- Account dropdown ----------
  const accountToggle = document.querySelector('[data-fc-account-toggle]');
  const accountDropdown = document.querySelector('[data-fc-account-dropdown]');
  if (accountToggle && accountDropdown) {
    accountToggle.addEventListener('click', (e) => {
      e.stopPropagation();
      const isOpen = accountToggle.getAttribute('aria-expanded') === 'true';
      accountToggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      accountDropdown.setAttribute('aria-hidden', isOpen ? 'true' : 'false');
    });
    document.addEventListener('click', (e) => {
      if (!accountToggle.contains(e.target) && !accountDropdown.contains(e.target)) {
        accountToggle.setAttribute('aria-expanded', 'false');
        accountDropdown.setAttribute('aria-hidden', 'true');
      }
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        accountToggle.setAttribute('aria-expanded', 'false');
        accountDropdown.setAttribute('aria-hidden', 'true');
      }
    });
  }

  // ---------- Mobile Country accordion ----------
  const countryBtn = document.querySelector('[data-fc-mobile-country]');
  const countryList = document.querySelector('[data-fc-mobile-country-list]');
  if (countryBtn && countryList) {
    countryBtn.addEventListener('click', () => {
      const isOpen = countryBtn.getAttribute('aria-expanded') === 'true';
      countryBtn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      countryList.setAttribute('data-open', isOpen ? 'false' : 'true');
    });
  }
})();

/* ==========================================================================
   FluffCo — Labor Day / seasonal flash banner countdown
   Standalone. Does NOT touch fluffco-header.js.

   Counts down to a fixed instant (data-fc-ldb-end, ISO 8601 with an explicit
   UTC offset) — NOT to local midnight. The sale has a real end date.

   The theme's mobile drawer is positioned with --fc-header-bottom, which
   fluffco-header.js recalculates on window resize. That function is private to
   its IIFE, so instead of touching it we dispatch a resize event after the
   banner's height changes. Same result, zero coupling.
   ========================================================================== */
(function () {
  'use strict';

  var banner = document.querySelector('[data-fc-ldb]');
  if (!banner) return;

  var daysEl = banner.querySelector('[data-fc-ldb-days]');
  var hrsEl  = banner.querySelector('[data-fc-ldb-hrs]');
  var minEl  = banner.querySelector('[data-fc-ldb-min]');
  var secEl  = banner.querySelector('[data-fc-ldb-sec]');
  var closeBtn = banner.querySelector('[data-fc-ldb-close]');

  var startTs  = Date.parse(banner.getAttribute('data-fc-ldb-start'));
  var endTs    = Date.parse(banner.getAttribute('data-fc-ldb-end'));

  if (!isFinite(endTs)) return;

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  // Clock-skew guard: a shopper with a badly-set device clock would otherwise
  // see a nonsense countdown. Trust the server epoch when the two disagree by
  // more than a minute — smaller deltas are just network latency, not skew.
  var skew = 0;
  var serverNow = parseInt(banner.getAttribute('data-fc-ldb-now'), 10) * 1000;
  if (isFinite(serverNow) && serverNow > 0) {
    var delta = serverNow - Date.now();
    if (Math.abs(delta) > 60000) skew = delta;
  }
  function now() { return Date.now() + skew; }

  // Let the theme re-measure the sticky header height after we change it.
  function notifyHeightChange() {
    try { window.dispatchEvent(new Event('resize')); } catch (e) {}
  }

  var timer = null;

  function hide() {
    if (banner.getAttribute('data-dismissed') === 'true') return;
    banner.setAttribute('data-dismissed', 'true');
    if (timer) { clearInterval(timer); timer = null; }
    notifyHeightChange();
  }

  function tick() {
    // Re-verify the window client-side; guards against a full-page-cached
    // document being served after the sale has ended.
    var t = now();
    if (t >= endTs || (isFinite(startTs) && t < startTs)) { hide(); return; }

    var total = Math.floor((endTs - t) / 1000);
    var d = Math.floor(total / 86400);
    var h = Math.floor((total % 86400) / 3600);
    var m = Math.floor((total % 3600) / 60);
    var s = total % 60;

    var wasZero = banner.getAttribute('data-days-zero') === 'true';
    var isZero  = d <= 0;
    if (wasZero !== isZero) {
      banner.setAttribute('data-days-zero', isZero ? 'true' : 'false');
      notifyHeightChange(); // pill removal can reflow the row on narrow screens
    }

    if (daysEl) daysEl.textContent = pad(d);
    if (hrsEl)  hrsEl.textContent  = pad(h);
    if (minEl)  minEl.textContent  = pad(m);
    if (secEl)  secEl.textContent  = pad(s);
  }

  tick();
  timer = setInterval(tick, 1000);

  // Pause while the tab is hidden — no point burning a timer per second on a
  // background tab. Resync immediately on return so digits aren't stale.
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) {
      if (timer) { clearInterval(timer); timer = null; }
    } else if (!timer && banner.getAttribute('data-dismissed') !== 'true') {
      tick();
      timer = setInterval(tick, 1000);
    }
  });

  if (closeBtn) {
    // Dismissal is intentionally NOT persisted — the banner returns on every
    // page load. Hiding lasts only for the current page view.
    closeBtn.addEventListener('click', hide);
  }
})();